import { Component, OnInit } from '@angular/core';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Participant } from 'src/app/shared/models/Participant';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { Form0ChurchAdress } from 'src/app/shared/models/Form0ChurchAdress';
import { WsAttendanceKey } from 'src/app/shared/models/WsAttendanceKey';
import * as FileSaver from 'file-saver';
import autoTable from 'jspdf-autotable'
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';

@Component({
  selector: 'app-partipant-form0',
  templateUrl: './partipant-form0.component.html',
  styleUrls: ['./partipant-form0.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class PartipantForm0Component implements OnInit {

  //Elementos de traducción inicio.
  lstRespTranslate: TranslateRelLabelVO[];
  lbl_name: string = "name_";
  lbl_lastName: string = "last_name_";
  lbl_birth_date: String = "birth_Date_";
  lbl_gender: string = "gender_";
  lbl_language: string = "language_";
  lbl_email: string = "email_";
  lbl_cell_phone: string = "cell_phone_";
  lbl_search: string = "search_";
  lbl_back: String = "back_";
  lbl_church: string = "churchs_";
  lbl_service: string = "service_";
  lbl_schedule: string = "schedule_";
  lbl_participants: String = "participants_";
  lbl_id: string = "id_";
  lbl_new_record: string = "new_record_";
  lbl_attendance: string = "attendance_";
  lbl_total: string = "total_";
  lbl_there_are: string = "there_are_";
  lbl_edit: String = "edit_";
  lbl_delete_record: string = "delete_record_";
  lbl_confirm: string = "confirm_";
  lbl_wish_continue: string = "wish_to_continue_";
  lbl_place_where_provide: String = "place_where_provide_";
  //Elementos de traducción fin
  //Elementos de seguridad inicio
  token: string;
  security: SecurityDocument;
  //Elementos de seguridad fin

  wrksId: string;
  listParticipant: Participant[];
  selectedParticipant: Participant;

  optionDialog: boolean;
  submitted: boolean;
  mailValid: boolean;

  participantView: Participant;

  listLanguage: CategoryLan[];
  selectedLanguage: CategoryLan;

  listGender: CategoryLan[];
  selectedGender: CategoryLan;

  form0Detail: Form0ChurchAdress;
  birthday: Date;

  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService) {
    this.route.queryParams.subscribe(params => {
      let wrksIdParam = params['wrksId'];
      this.token = params['token'];
      if (wrksIdParam) {
        this.wrksId = wrksIdParam

        this.loadParticipantByServices();
        this.getSecurity();
      } else {
        this.messageService.add({ severity: 'warn', summary: 'Busqueda Servicio', detail: 'No hay Servicio que buscar', life: 3000 });
      }

    });
  }

  ngOnInit(): void {

  }

  loadParticipantByServices() {

    this.apiService.getParticipantsByServices(this.wrksId).then(
      participants => {
        this.listParticipant = participants;

      });

    this.apiService.getDetailForm0({ wrksId: this.wrksId }).then(
      detail => {
        this.form0Detail = detail;

      });



  }


  createParticipant() {
    this.participantView = {};
    this.redirectDetail(this.participantView);
  }

  redirectDetail(participant: Participant) {
    const objToSend = { participant: participant, service: this.form0Detail, token: this.token }
    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(objToSend))
    }
    this.router.navigate(['secretary/participantDtl'], navigationExtras);
  }

  redirectAsistencias() {
    let params = {};
    if (this.form0Detail) {
      params["wrksId"] = this.form0Detail.wrksId;
      params["token"] = this.token;
    }
    this.router.navigate(['secretary/sessionWrks'], { queryParams: params });
  }

  deleteParticipant(participant: Participant) {

    this.confirmationService.confirm({
      message: this.lbl_wish_continue + ' ' + this.lbl_delete_record + ', ' + this.lbl_participants + ': ' + participant.name + participant.lastName + ' ?',
      header: this.lbl_confirm + ' ' + this.lbl_delete_record,
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.deleteParticipantService(participant.particiId);

      }
    });
  }

  deleteParticipantService(participantId: string) {
    this.apiService.deleteParticipantForm0({
      wrksId: this.wrksId,
      id: participantId,
      language: this.security.language
    }).then(
      data => {

        this.messageService.add({ severity: 'success', summary: 'Eliminar Participante', detail: 'Se elimino participante correctamente', life: 3000 });
        this.loadParticipantByServices();
      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'Eliminar Participante', detail: error, life: 3000 });
      });
  }

  exportExcel() {

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.listParticipant);

      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "participants");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const date = new Date();
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const formattedDate = `${year}${month}${day}`;

    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, 'listParticipantsForm0_' + formattedDate + '.xlsx');
  }

  exportPdf() {
    const date = new Date();
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const formattedDate = `${year}${month}${day}`;

    let headerPDF: any[] = [["ID Participante", "Nombre", "Apellidos", "Fecha Nacimiento", "Genero", "Idioma", "Email", "Celular"]];
    let data: any[] = this.covertJsonToListOfList(this.listParticipant);
    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default('landscape', 'cm', 'a4');

        autoTable(
          doc, {
          head: headerPDF,
          body: data,
          didDrawCell: (data) => {

          },
        });
        doc.save('listParticipantsForm0_' + formattedDate + '.pdf');
      })
    })
  }

  covertJsonToListOfList(jsonData: any): any[] {
    let listJson: any[] = [];
    for (var x in jsonData) {
      var temp = [jsonData[x].particiId, jsonData[x].name, jsonData[x].lastName, jsonData[x].birthDate, jsonData[x].gender, jsonData[x].firstLang, jsonData[x].email, jsonData[x].mobPhon];
      listJson.push(temp);
    }
    return listJson;
  }

  getSecurity() {
    //.
    this.apiService.findSecurityById(
      {
        "id": this.token
      }
    ).then(
      data => {
        this.security = data;
        this.getTranslatedLabels();
        //.
      });
  }
  getTranslatedLabels() {
    let map = new Map();
    let lstCat: CategoryLan[];

    this.apiService.listByLanguageMultFields(
      {
        'language': this.security.language,
        'region': this.security.region,
        'lstLabels': [this.lbl_name, this.lbl_lastName, this.lbl_birth_date, this.lbl_gender,
        this.lbl_language, this.lbl_email, this.lbl_cell_phone, this.lbl_search, this.lbl_back, this.lbl_church,
        this.lbl_schedule, this.lbl_service, this.lbl_participants, this.lbl_id, this.lbl_new_record,
        this.lbl_attendance, this.lbl_there_are, this.lbl_total, this.lbl_edit, this.lbl_delete_record, this.lbl_confirm, this.lbl_wish_continue, this.lbl_place_where_provide]
      }
    ).then(
      trDocs => {
        this.lstRespTranslate = trDocs;

        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });

        this.lbl_name = map.get(this.lbl_name);
        this.lbl_lastName = map.get(this.lbl_lastName);
        this.lbl_birth_date = map.get(this.lbl_birth_date);
        this.lbl_gender = map.get(this.lbl_gender);
        this.lbl_language = map.get(this.lbl_language);
        this.lbl_email = map.get(this.lbl_email);
        this.lbl_cell_phone = map.get(this.lbl_cell_phone);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_church = map.get(this.lbl_church);
        this.lbl_service = map.get(this.lbl_service);
        this.lbl_schedule = map.get(this.lbl_schedule);
        this.lbl_back = map.get(this.lbl_back);
        this.lbl_id = map.get(this.lbl_id);
        this.lbl_participants = map.get(this.lbl_participants);
        this.lbl_new_record = map.get(this.lbl_new_record);
        this.lbl_there_are = map.get(this.lbl_there_are);
        this.lbl_attendance = map.get(this.lbl_attendance);
        this.lbl_total = map.get(this.lbl_total);
        this.lbl_edit = map.get(this.lbl_edit);
        this.lbl_delete_record = map.get(this.lbl_delete_record);
        this.lbl_confirm = map.get(this.lbl_confirm);
        this.lbl_wish_continue = map.get(this.lbl_wish_continue);
        this.lbl_place_where_provide = map.get(this.lbl_place_where_provide);
      });
  }
  goBack() {
    window.close();
  };
}
